import { Component, ComponentChildren } from 'preact'
import { LastEditedCell } from './Columns'
/* eslint-disable import/no-internal-modules */
import Header from '@insided/deprecated-control/header'
import Table from '@insided/deprecated-preact-components/table/Table'
import EmptyPage from '@insided/deprecated-preact-components/empty-page/EmptyPage'
import AlertComponent from '@insided/deprecated-control/ui-components/AlertComponent'

export interface DraftOverviewProps {
  articles: Array<{
    article_id: string
    title: ComponentChildren
    created_by: string
    category: string
    last_edited: {
      last_edited_timestamp: number
      last_edited_by: string
    }
  }>
  defaultCdn: string
}

export interface DraftOverviewState {
  flashMessage?: string
}

class DraftOverview extends Component<DraftOverviewProps, DraftOverviewState> {
  prepareTableData() {
    const urlBase = window.location.origin + '/draft/'
    return this.props.articles.map((draft) => {
      draft.title = <a href={urlBase + draft.article_id}>{draft.title}</a>
      return draft
    })
  }

  setFlashMessage() {
    const urlParams = decodeURIComponent(window.location.search)
    if (urlParams.startsWith('?deleted')) {
      const draftTitle = urlParams.substring(urlParams.indexOf('title=') + 6)
      this.setState({ flashMessage: `Draft '${draftTitle}' has been deleted` })
    }
  }

  componentDidMount() {
    this.setFlashMessage()
  }

  render() {
    const { articles, defaultCdn } = this.props
    const { flashMessage } = this.state

    const model = [
      {
        header: 'Title',
        accessor: 'title'
      },
      {
        header: 'Last edited',
        accessor: 'last_edited',
        cell: LastEditedCell()
      },
      {
        header: 'Author',
        accessor: 'created_by'
      },
      {
        header: 'Category',
        accessor: 'category'
      }
    ]
    const rows = this.prepareTableData()
    return (
      <div>
        {flashMessage ? (
          <AlertComponent sticky messageType='success' message={flashMessage} isVisibleFor={5000} />
        ) : (
          ''
        )}
        <Header title='Drafts' disableCancelButton disableSaveButton />
        {!articles.length ? (
          <EmptyPage
            img_src={`${defaultCdn}/images/empty_page.png`}
            header='Your draft box is empty'
            text={
              'Seems like no one on your team has created any draft articles. \n Start now by creating a new article'
            }
            button={{ link: '/content/new/article', text: 'New article' }}
          />
        ) : (
          <div className='drafts-overview'>
            <Table firstColumnSticky model={model} rows={rows} rowId='article_id' />
          </div>
        )}
      </div>
    )
  }
}

export default DraftOverview
